import * as React from 'react'
import styled, { css } from 'styled-components'
import ReactModal from 'react-modal'
import media from '../../../services/generateMediaQueries'
import CinemaBreak from '../../../assets/img/cinema/cinema-break.webp'
import Background from '../../../assets/img/cinema/cinema-header.webp'
import Icon from '../../ui/Icon/Icon'

const StyledReactModal = styled(ReactModal)`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  transition: all var(--animation-duration) var(--animation-easing);

  &.ReactModal__Content {
    &--after-open {
      opacity: 1;
      transition: all var(--animation-duration) var(--animation-easing);
    }

    &--before-close {
      opacity: 0;
      transition: all calc(var(--animation-duration) / 2)
        var(--animation-easing);
    }
  }

  ${media.lessThan('small')`
    top: 0;
    right: 0;
    height: 100% !important;
    border-radius: 0;
    max-width: unset;
    max-height: unset;
  `}
`

const ModalContentWrapper = styled.div`
  border-radius: 8px;
  overflow: auto;
  max-height: 100vh;
  width: 100%;
`

const DefaultCloseButton = styled.button`
  position: absolute;
  color: #ffffff;
  border: 0;
  top: 15px;
  right: 15px;
  font-size: 25px;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.5);
  width: 32px;
  height: 32px;
  padding: 4px;
  border-radius: 100%;
  outline: none;

  ${props =>
    props.zIndex &&
    css`
      z-index: ${props.zIndex + 1};
    `}

  > svg {
    vertical-align: baseline;
  }
`

const ModalContent = styled.div`
  position: relative;
  margin: 3rem auto;
  width: 325px;
  min-height: 400px;
  border-radius: 8px;
  overflow: hidden;
  background: #ffffff;

  ${media.lessThan('small')`
    margin: 0;
    height: 100%;
    width: 100%;
    border-radius: 0;
  `}
`

const Content = styled.div`
  text-align: center;
`

const CinemaIcon = styled.img.attrs({ src: CinemaBreak })`
  width: 10rem;
  margin-top: -7.5rem;
  margin-bottom: 0.5rem;
`

const Header = styled.img`
  width: 100%;
`

const Title = styled.h3`
  color: var(--color-primary);
  font-size: 1.125rem;
  font-weight: var(--font-weight-boldest);
  line-height: 1.5625rem;
  text-align: center;
  margin: 1rem 0;
  position: relative;
  z-index: 1;
`

const Description = styled.p`
  font-size: 0.875rem;
  letter-spacing: 0.1px;
  line-height: 1.3125rem;
  margin: 2rem 0;
  padding: 0 1.6875rem;
  text-align: center;
`

const overlay = {
  zIndex: 10000,
  background: 'rgba(0, 0, 0, 0.8)',
}

const content = {}

function CinemaModal(props) {
  const {
    show,
    onClose,
    zIndex,
    shouldCloseOnOverlayClick,
    description,
    ...restProps
  } = props
  return (
    <StyledReactModal
      isOpen={show}
      style={{
        overlay: {
          ...overlay,
          ...(zIndex ? { zIndex } : {}),
        },
        content,
      }}
      onRequestClose={onClose}
      closeTimeoutMS={150}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      bodyOpenClassName="sticky-modal-open"
      htmlOpenClassName="sticky-modal-open"
      {...restProps}
    >
      <ModalContentWrapper>
        <ModalContent>
          <DefaultCloseButton zIndex={zIndex} onClick={onClose}>
            <Icon name="x" />
          </DefaultCloseButton>
          <Content>
            <Header
              src={Background}
              alt="Our Cinemas are back on the Big Screen"
            />
            <CinemaIcon alt="" />
            <Title>
              OUR CINEMAS ARE BACK <br />
              ON THE BIG SCREEN
            </Title>
            <Description>{description}</Description>
          </Content>
        </ModalContent>
      </ModalContentWrapper>
    </StyledReactModal>
  )
}

CinemaModal.defaultProps = {
  // TODO: specify default props
}

CinemaModal.propTypes = {
  // TODO: specify prop types
}

export default CinemaModal
